import { environment } from './../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportService } from 'src/app/services/report.service';
import { TokenExpireService } from 'src/app/services/token-expire.service';
import { CustomLoaderService } from '../../services/custom-loader.service';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';

declare var $: any;
@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss']
})
export class FormsComponent implements OnInit {
  IsSubscribed = environment.IsSubscribed;
  ompanyName = environment.CompayName;
  ArrayofResposnse: any = [];
  ArrTempFundData: any = [];
  ArrnfoData: any = [];
  SearchFund: string = '';
  constructor(
    private exploreServices: ReportService,
    private Loader: CustomLoaderService,
    private Logout: TokenExpireService,
    private router: Router,
    private route: ActivatedRoute,
    private EncrdecrService: EncrdecrService
  ) {}
  ngAfterViewInit() {
    $('#MainNAV .nav-item .nav-link').removeClass('active');
    $('#Id_ValueAdds .nav-link').addClass('active');
  }
  ngOnInit() {
    $('.MainBg').css('min-height', window.innerHeight - 112);

    setTimeout(() => {
      this.Loader.hide();
    }, 1000);
  }
  Back() {
    window.location.reload();
  }
}
